document.addEventListener('submit', (ev) => {
  const form = ev.target as HTMLFormElement | null
  if (!form) return
  if (!form.closest('[data-print-on-submit]')) return
  ev.preventDefault()
  window.print()
})
